import { graphql } from 'react-relay';

export const fundFragment = graphql`
    fragment Fund_fund on Funds {
        fundsname
        category
        distribution
        currency
        largeinvestmentfonds
        traits
        tranches(first: 1000) {
            edges {
                node {
                    currency
                    distribution
                    id
                    isin
                    url
                    institutional
                    salesadmission
                }
            }
        }
    }
`;
